import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  getSearchLinks() {
    const url = FetchHelpers.toCDN(apiRoutes.searchLinksPath(1));
    return FetchHelpers.get(url);
  },
};
